export const TRAINERS_CONSTS = {
    GET_TEAM: "GET_TEAM",
    UPDATE_TEAM: "UPDATE_TEAM",
    GET_TRAINERS: "GET_TRAINERS",
    CREATE_TRAINER: "CREATE_TRAINER",
    GET_TRAINER_BY_ID: "GET_TRAINER_BY_ID",
    UPDATE_TRAINER_BY_ID: "UPDATE_TRAINER_BY_ID",
    DELETE_TRAINER_BY_ID: "DELETE_TRAINER_BY_ID",
};
